<template>
  <div>
    <div id="myDoughnut"></div>
  </div>
</template>

<script>
import echarts from "echarts";

export default {
  name: "DoughnutChart",
  props: {
    travelModeInfo: {
      type: Array,
      default: function() {
        return [];
      },
    },
  },
  data() {
    return {
      chartData: [],
      firstShow: true,
    };
  },
  mounted() {},
  watch: {
    travelModeInfo(newValue, oldValue) {
      if (newValue.length == 0) {
        this.chartData = [
          { name: "", value: 0, itemStyle: { color: "#DCDDE0" } },
        ];
      } else {
        this.chartData = newValue;
      }
      this.drawLine();
      this.firstShow = false;
    },
  },
  methods: {
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      let myDoughnut = echarts.init(
        document.getElementById("myDoughnut"),
        null,
        {
          width: 136,
          height: 136,
        }
      );
      // 绘制图表
      myDoughnut.setOption({
        tooltip: {
          trigger: "item",
          triggerOn: 'click',
          formatter: function(params) {
            return `
              <div>${params.name}: ${params.value}起</div>
            `
          }
        },
        legend: {
          show: false,
        },
        series: [
          {
            name: "",
            hoverAnimation: false,
            show: false,
            type: "pie",
            radius: ["64.7%", "100%"],
            avoidLabelOverlap: false,
            itemStyle: {
              borderColor: "#fff",
              borderWidth: 2,
            },
            label: {
              show: false,
            },
            emphasis: {
              label: {
                show: false,
              },
            },
            labelLine: {
              show: false,
            },
            data: this.chartData,
          },
        ],
      });
    },
  },
};
</script>
